import React from "react";
import './header.css';
import CTA from './CTA'
import HEADSHOT from '../../assets/luis_headshot.jpg'
import HeaderSocial from "./HeaderSocial";
import { profile } from "../../data/profile";


const Header = () => {

    return(
        <header id="top">
            <div className="container header__container">
                <div className="header__content">
                    <span className="section__eyebrow">Hi, I'm</span>
                    <h1>{profile.name}</h1>
                    <p className="header__title">{profile.title}</p>
                    <p className="header__pitch text-muted">{profile.pitch}</p>
                    <CTA/>
                    <HeaderSocial/>
                </div>

                <div className="headshot">
                    <img src={HEADSHOT} alt={`Portrait of ${profile.name}`}/>
                </div>
            </div>
        </header>
    )
}

export default Header
